
import { ContactEntity } from '../contact';
import { Entity } from '../entity';
import { Source } from '../../enums';

export enum WorkOrderResourceStatus {
    Assigned = 'Assigned',
    Dispatched = 'Dispatched',
    Enroute = 'Enroute',
    OnSite = 'Onsite',
    CheckedOut = 'Checked Out',
    Completed = 'Completed',
    OnHold = 'On Hold'
}

export enum WorkOrderResourceSource {
    Allocation = 'Allocation',
    WorkOrder = 'WorkOrder'
}

export enum SendEmailType {
    Dispatched = 'Dispatched',
    Unassigned = 'Unassigned',
    Cancelled = 'Cancelled',
    Closed = 'Closed',
    OnHold = 'OnHold',
    Reissued = 'Reissued',
    Approved = 'Approved',
    Rework = 'Rework',
    DispatchedByConnect = 'Dispatched By Connect'
}

export interface ResourceEntity extends ContactEntity {
    email: string;
    phone: string;
    mobile: string;
}

export interface WorkOrderResource extends Entity {

    job: Entity;
    workOrder: Entity;

    parent?: ContactEntity;

    resource: ContactEntity;
    status: WorkOrderResourceStatus;

    teams?: Entity[];
    allocations?: Entity[];

    source: Source;
    module: WorkOrderResourceSource;

    completedDate?: Date;
    lastDispatchedDateTime?: Date;
    lastOnSite?: Date;

    createdAt?: Date;
    updatedAt?: Date;

}

export interface ActiveWorkOrderResource {
    job: Entity;
    workOrder: Entity;
    status: WorkOrderResourceStatus;
    date: Date;
}

export interface WorkOrderResourceSummary extends Entity {
    resource: ResourceEntity;
    status: WorkOrderResourceStatus;
    hasAllocations: boolean;
}